import React, { useContext, useMemo, useState } from 'react';
import PropTypes from 'prop-types';

import Card from './card';
import ManagedInput from 'components/form/managed_input';
import Options from './options';
import SettingsContext from '../settings_context';

export default function AvailableOptions({ hideSearch, options, optionsLabel, selection, onAdd, onAddAll }) {
  const settings = useContext(SettingsContext);

  const [searchText, setSearchText]  = useState('');

  const availableOptions = useMemo(() => {
    return options.filter((option) => {
      const isSelected = selection.some((selectedOption) => {
        return selectedOption[settings.optionValueName] === option[settings.optionValueName];
      });

      return !isSelected && option[settings.optionLabelName].toLowerCase().includes(searchText.toLowerCase());
    });
  }, [searchText, selection]);

  let control;
  if (availableOptions.length) {
    control = (
      <a className="clickable" onClick={onAddAll}>
        Add all
      </a>
    );
  }

  return (
    <Card
      control={control}
      header={`Available ${optionsLabel}`}
    >
      {!hideSearch && (
        <ManagedInput
          className="form-control mb-3"
          name="search"
          placeholder="Search"
          value={searchText}
          onValueChange={setSearchText}
        />
      )}

      <Options options={availableOptions} onOptionClick={onAdd} />
    </Card>
  );
}

AvailableOptions.propTypes = {
  hideSearch: PropTypes.bool,
  options: PropTypes.array.isRequired,
  optionsLabel: PropTypes.string,
  selection: PropTypes.array.isRequired,
  onAdd: PropTypes.func.isRequired,
  onAddAll: PropTypes.func.isRequired,
};
